<template>
    <div style=" height: 100%;">
        <keep-alive>
            <router-view :key="key">
            </router-view>
        </keep-alive>

        <mobileFooter />
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    name: "mobileHome",
    data() {
        return {
        };
    },

    computed: {
        key() {
            return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
        }
    },

    created() {
    },
    methods: {

    },
};
</script>



// WEBPACK FOOTER //
// src/views/login/mobileHome.vue